import { Col, Row, Skeleton } from "antd";
import styles from "./landing.module.scss";
import ListView from "../../templates/ListView/ListView";
import { PicCenterOutlined } from "@ant-design/icons";
import React, { useEffect, useRef, useState } from "react";
import CardView from "../../templates/CardView/CardView";
import { useTenders } from "../../tools/api";

import { CheckToken } from "../../tools/services";
import { useSelector } from "react-redux";
import { isEmpty, isEmptyObject } from "../../tools/tools";
import Layouts, { useLayouts } from "../layout/layouts";
import ADS from "../../components/ads/Ads";
import WinnerModal from "./details/winner/winner-modal";
import { useLocation, useSearchParams } from "react-router-dom";
import InCreaseWallet from "../../components/increaseWallet/InCreaseWallet";
import Loading from "../../components/loader/loading";
const Landing = () => {
  const location = useLocation();
  const [searchParam] = useSearchParams();

  const { refreshUser, checkLoginUser } = useLayouts();

  //loading
  const [loadingSkelet, setLoadingSkelet] = useState(true);

  //hooks tenders
  const { queryTenderNumbers, queryCurrentUserBids, queryTenderNumberById } = useTenders();

  //check Login
  const [isLogin, setLogin] = useState();

  //user Info
  const [user, setUser] = useState({});

  //list tenders
  const [tenders, setTenders] = useState([]);
  const [tendersOrg, setOrgTenders] = useState([]);

  //categories
  const [categories, setCategories] = useState([
    {
      id: "all",
      title: "همه",
    },
    {
      id: "min",
      title: "کمترین قیمت",
    },
    {
      id: "max",
      title: "بیشترین قیمت",
    },
  ]);

  //filter by tab show
  const [selectedTab, setSelectedTab] = useState(-1);

  const [winnerInfo, setWinnerInfo] = useState([]);
  const [winnerIsOpenModal, setWinnerIsOpenModal] = useState(false);

  const [openIncress, setOpenIncress] = useState(false);
  const [localInvoiceId, setLocalInvoiceId] = useState("");
  const [amountCharge, setAmountCharge] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const bankRef = useRef("");

  useEffect(() => {
    const checkLogin = async () => {
      const isCheck = await checkLoginUser();
      if (isCheck) {
        setLogin(isCheck);
        const userInfo = await refreshUser();
        setUser(userInfo || {});
      }
    };
    checkLogin();
  }, [checkLoginUser, refreshUser]);

  useEffect(() => {
    const intialData = async () => {
      try {
        setLoadingSkelet(true);

        const response = await queryTenderNumbers("");
        if (response) {
          let getCat = response.map((item) => ({ id: item?.auctionProductTypeiId, title: item?.auctionProductType }));
          getCat = Array.from(new Set(getCat.map((item) => JSON.stringify(item)))).map((item) => JSON.parse(item));
          setCategories((prev) => [...prev, ...getCat]);
          setTenders(response);
          setOrgTenders(response);
        } else {
          setCategories({});
        }
        if (location?.state?.winner) {
          checkWinner();
        }

        setLoadingSkelet(false);
      } catch (error) {
        setLoadingSkelet(false);
        console.error(error);
      }
    };
    intialData();
  }, []);

  const checkWinner = async () => {
    try {
      setLoadingSkelet(true);
      const payload = {
        searchconfigmodel: {
          sort: "",
          filter: "",
          entriesperpage: 10,
          page: 0,
          totalrowcount: 0,
        },
        auctionstatus: [3],
      };
      const userBids = await queryCurrentUserBids(payload);

      if (userBids && !userBids?.HasError) {
        if (userBids.Result.length > 0) {
          const winnerTender = userBids.Result.filter((item) => item.hasWon);
          if (winnerTender.length > 0) {
            const resTNumber = await queryTenderNumberById(winnerTender[0]?.auctionProductId);
            if (resTNumber) {
              const queryUser = await refreshUser();
              const qUser = { ...queryUser, ...winnerTender[0], ...resTNumber };
              setWinnerIsOpenModal(true);
              setWinnerInfo(qUser);
            }
          }
        }
      }
      setLoadingSkelet(false);
    } catch (error) {
      console.log(error);
      setLoadingSkelet(false);
    }
  };

  //show type view
  const [selectView, setSelectView] = useState("list");

  const handleClickُTab = (index) => {
    setSelectedTab(index);
    const element = document.getElementById(`tab-${index}`);
    if (element) {
      element.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
    let _temp = tendersOrg;
    if (typeof index === "number") {
      _temp = _temp.filter((item) => item?.auctionProductTypeiId === index);
    } else if (index === "max") {
      _temp = _temp.sort((a, b) => b?.startPrice - a?.startPrice);
    } else if (index === "min") {
      _temp = _temp.sort((a, b) => a?.startPrice - b?.startPrice);
    } else {
      _temp = tendersOrg;
    }
    setTenders(_temp);
  };

  const handleCallBackWinner = (value) => {
    setWinnerIsOpenModal(false);
    if (value.state === "pending") {
      setAmountCharge(value.amount);
      setOpenIncress(true);
    }
  };

  useEffect(() => {
    if (!isEmpty(searchParam.get("localInvoiceId"))) {
      const getLocalInvoiceID = searchParam.get("localInvoiceId");
      setLocalInvoiceId(getLocalInvoiceID);
      setOpenIncress(true);
    }
  }, []);

  const handleCallBackCharge = (value) => {
    setIsLoading(true);
    if (value?.length > 0) {
      bankRef.current.innerHTML = value;
      document.querySelector('form[action="https://asan.shaparak.ir"]').submit();
    } else if (value === false) {
      setLocalInvoiceId("");
      setOpenIncress(false);
    } else {
      setLocalInvoiceId("");
      setOpenIncress(false);
      checkWinner();
    }
    setIsLoading(false);
  };

  return (
    <>
      <div className={styles.holdertabFilter}>
        <div className={styles.filteritem}>
          <div className={styles.holder_row}>
            {categories.map((tab, index) => (
              <div
                key={index}
                id={`tab-${tab.id}`}
                className={`${styles.item} ${tab.id === selectedTab ? styles.active : ""}`}
                onClick={() => handleClickُTab(tab.id)}
                data-id={tab.id}
              >
                {tab.title}
              </div>
            ))}
          </div>
        </div>
        <div className={styles.showfilter}>
          <PicCenterOutlined onClick={() => setSelectView("list")} className={selectView === "list" && styles.active} />
          <PicCenterOutlined onClick={() => setSelectView("card")} className={selectView === "card" && styles.active} rotate={90} />
        </div>
      </div>
      <div className="holdlistshownumber">
        <Row gutter={selectView === "card" ? 30 : 0} style={{ display: selectView !== "card" && "block" }}>
          {tenders.map((item, key) => (
            <React.Fragment key={key}>
              {selectView === "list" ? (
                <ListView item={item} />
              ) : (
                <Col xxl={6} xl={8} lg={12} md={12} sm={24} xs={24}>
                  <CardView item={item} />
                </Col>
              )}
            </React.Fragment>
          ))}
        </Row>
      </div>
      <WinnerModal value={winnerInfo} open={winnerIsOpenModal} callback={handleCallBackWinner} />
      <InCreaseWallet
        open={openIncress}
        planid={process.env.REACT_APP_INCREASE_LOGIN}
        msisdn={user?.telnoone}
        localInvoiceId={localInvoiceId}
        price={amountCharge}
        callback={handleCallBackCharge}
        activePrice={true}
      />
      <div ref={bankRef}></div>
      <Loading isOpen={isLoading} />
    </>
  );
};

export default Landing;
